import * as React from 'react';
import { Link as LinkComponent, LinkProps } from 'react-router';

const Link = (props: LinkProps): React.JSX.Element => <LinkComponent {...props} to={props.to || {}} />;

export default Link;
